export default __webpack_public_path__ + "static/picto-service-clientele-black-e34b569578808ed0a6f4f9c6a890894d.png";